import React, { Component } from 'react';
import { observer } from 'mobx-react';
import BulkListingsStore, { FILTER_CATEGORIES } from './BulkListingsStore';
import { observable } from 'mobx';
import { Text, Whitespace } from '../../../components_new/common';
import InputStyle from '../../../components_new/common/FormComponents/InputStyle';
import Button from '../../../components_new/common/FormComponents/Button';
import Modal from '../../../components_new/Modal';
import Description, {
  TextArea,
} from '../../../components_new/addListing/Description';
import Select from '../../../components_new/addListing/Select';
import InputHeader from '../../../components_new/common/FormComponents/InputHeader';
import _ from 'lodash';
import { getp } from '../../../helpers/getProp';
import { allowNumericKeysOnly } from '../../../components_new/addListing/utils';
import Rules from '../../../components_new/addListing/Rules';
import PhotosUpload from '../../../components_new/addListing/PhotoUpload/PhotosUpload';
import { buildPhotoPath } from '../../../helpers/photoutils';

@observer
class BulkListings extends React.Component {
  @observable store = BulkListingsStore.create();
  @observable cId = null;
  componentWillMount() {
    // this.store.start(1);
  }

  start = () => {
    this.store.start(this.cId);
  };
  render() {
    const store = this.store;
    if (!store.listings || store.listings.length === 0) {
      return (
        <div>
          <Text>Enter a user profile id to proceed:</Text>
          <InputStyle
            value={this.cId}
            onChange={e => (this.cId = e.target.value)}
          />
          <Button primary onClick={this.start}>
            Go
          </Button>
        </div>
      );
    }

    return (
      <div className="g g-tc-a-8 b-0 bb-1 br-1 b-coolGray">
        <Cell>title</Cell>
        <Cell>description</Cell>
        <Cell>category</Cell>
        <Cell>price</Cell>
        <Cell>address</Cell>
        <Cell>rules</Cell>
        <Cell>photos</Cell>
        <Cell>actions</Cell>
        {store.listings.map(l => (
          <React.Fragment>
            <Cell listing={l} edit={() => store.edit('title', l.id)}>
              {l.title}
            </Cell>
            <Cell listing={l} edit={() => store.edit('description', l.id)}>
              {l.description}
            </Cell>
            <Cell listing={l} edit={() => store.edit('categoryName', l.id)}>
              {l.categoryName}
            </Cell>
            <Cell listing={l} edit={() => store.edit('basePrice', l.id)}>
              {l.basePrice}
            </Cell>
            <Cell listing={l} edit={() => store.edit('address', l.id)}>
              <div>{l.address}</div>
              <div>{l.address2}</div>
              <div>{l.address3}</div>
            </Cell>
            <Cell listing={l} edit={() => store.edit('rules', l.id)}>
              {l.ruleSummary}
            </Cell>
            <Cell
              listing={l}
              edit={() => store.edit('photos', l.id)}
              minWidth={200}
            >
              <div className="f f-columns">
                {l.photos.map(p => (
                  <img
                    className="h-40 w-40 brad-s"
                    src={buildPhotoPath('small', p.name)}
                  />
                ))}
              </div>
            </Cell>
            <Cell listing={l} noCopy>
              <div onClick={() => store.duplicate(l)}>
                <i className="fal fa-clone fa-lg mr-s" />
              </div>
              <div onClick={l.togglePublish}>
                <i
                  className={`${
                    l.isPublished ? 'fa fa-badge-check' : 'fal fa-badge'
                  } fa-lg secondary`}
                />
              </div>
            </Cell>
          </React.Fragment>
        ))}
        <Modal isOpen={store.editing} onShadowClick={store.saveAndClose}>
          <Editor subject={store.editing} store={store.editingListing} />
          <Whitespace />
          <Button secondary onClick={() => store.close()}>
            Cancel
          </Button>
        </Modal>
      </div>
    );
  }
}

export default BulkListings;

@observer
class Cell extends Component {
  @observable isHover = false;
  render() {
    const props = this.props;
    const { minWidth, edit, copy, paste, noCopy } = props;
    const err = getp(props, 'listing.error');
    return (
      <div
        className={`b-0 bt-1 bl-1 b-coolGray p-sxxx h-60 o-hidden relative ${
          this.isHover ? 'bg-primaryLightFaded' : ''
        } ${err ? 'bg-error' : ''} ${minWidth ? 'w-min-' + minWidth : ''}`}
        title={err}
        onMouseEnter={() => (this.isHover = true)}
        onMouseLeave={() => (this.isHover = false)}
        onClick={edit}
      >
        {props.children}
        {this.isHover && !noCopy && (
          <div className="absolute top-0 right-0 bottom-0 f-rows f-between-end bg-offWhite">
            <div className="pointer" onClick={copy}>
              <i className="fal fa-copy fa-lg" />
            </div>
            <div className="pointer" onClick={paste}>
              <i className="fal fa-clipboard fa-lg" />
            </div>
          </div>
        )}
      </div>
    );
  }
}

@observer
class Editor extends Component {
  @observable isHover = false;
  render() {
    const props = this.props;
    const { store } = props;
    if (
      props.subject === 'title' ||
      props.subject === 'description' ||
      props.subject === 'categoryName' ||
      props.subject === 'basePrice'
    ) {
      const categoryOptions = _.map(FILTER_CATEGORIES, (value, key) => {
        return (
          <option value={key} key={key}>
            {value}
          </option>
        );
      });
      return (
        <div>
          <InputHeader label="" />
          <InputStyle
            onChange={e => store.update('title', e.target.value)}
            value={store.title}
            placeholder="Title"
          />

          <Whitespace smaller />

          <InputHeader label="" />
          <TextArea
            onChange={e => store.update('description', e.target.value)}
            value={store.description}
            placeholder="Enter Description here..."
          />

          <Whitespace smaller />

          <InputHeader label="Pick a category" />
          <Select
            onChange={e => store.update('category', +e.target.value)}
            value={store.category}
          >
            <option value="" />
            {categoryOptions}
          </Select>
          <InputHeader label="Daily Rate" />
          <InputStyle
            onChange={e => store.update('basePrice', +e.target.value)}
            value={store.basePrice}
            onKeyPress={allowNumericKeysOnly}
            min="1"
            max={9999}
            maxlength="4"
            type="number"
          />
        </div>
      );
    } else if (props.subject === 'address') {
      return (
        <div>
          <InputHeader label="Street Address" />
          <InputStyle
            onChange={e => store.update('street', e.target.value)}
            value={store.street}
            placeholder="Street Address"
          />

          <Whitespace smaller />

          <InputHeader label="Apt, suite, Bldg, (optional)" />
          <InputStyle
            onChange={e => store.update('buildingName', e.target.value)}
            value={store.buildingName}
            placeholder="Apt, suite, Bldg, (optional)"
          />

          <Whitespace smaller />

          <div className="g g-tc-fr-2 g-g-l">
            <div>
              <InputHeader label="City" />
              <InputStyle
                onChange={e => store.update('city', e.target.value)}
                value={store.city}
                placeholder="City"
              />
            </div>

            <div>
              <InputHeader label="State" />
              <InputStyle
                onChange={e => store.update('state', e.target.value)}
                value={store.state}
                placeholder="State"
              />
            </div>
          </div>

          <Whitespace smaller />
          <InputHeader label="Zipcode" />
          <InputStyle
            onChange={e => store.update('zipcode', e.target.value)}
            value={store.zipcode}
            placeholder="Zipcode"
          />
        </div>
      );
    } else if (props.subject === 'rules') {
      return (
        <div>
          <Rules store={store} nextPage={() => {}} admin />
        </div>
      );
    } else if (props.subject === 'photos') {
      return (
        <div>
          <PhotosUpload
            small
            store={store}
            placeholder="Click here to upload photos or drag them in. PNG, JPG, and JPEG supported."
            savePhotos={store.savePhoto}
            removeListingPhoto={store.deletePhoto}
          />
        </div>
      );
    } else if (props.subject === 'actions') {
      return <div>'actions'</div>;
    }
    return <div>Oops! No subject</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/siteadmin/BulkListings/BulkListings.js